import React from 'react';
import { Section, Table } from 'Templates';

const DraggerRows = [
	{
		name: 'new Dragger(',
		type: '',
		default: '',
		description: '',
	},
	{
		name: 'container,',
		type: 'string | element | node',
		default: '-',
		description: 'it is the container or the playground of the Dragger.',
	},
	{
		name: 'options',
		type: 'object',
		default: '-',
		description: 'It is the options of the Dragger.',
		data: [
			{
				name: '{',
				type: '',
				default: '',
				description: '',
			},
			{
				name: 'draggable,',
				type: 'string',
				default: '-',
				description: 'it is the query selector of the element children of container which are allowed to be drag.',
			},
			{
				name: 'droppable,',
				type: 'string',
				default: '-',
				description: 'it is the query selector of the element children of container which are allowed to be drop.',
			},
			{
				name: 'axis',
				type: "'x' | 'y'",
				default: 'null',
				description: <>when you have <b>draggable</b>. you can limit its axis by x or y.</>,
			},
			{
				name: 'allowBoundContainer,',
				type: 'boolean',
				default: 'true',
				description: 'it is use bound the draggable elements inside the container element.',
			},
			{
				name: 'allowExactDraggable,',
				type: 'boolean',
				default: 'false',
				description: 'it is use to target the exact draggable element, when true even if you targeted the children of the draggable elements, it still will not move.',
			},
			{
				name: 'autoscroll,',
				type: 'boolean',
				default: 'false',
				description: 'it is use to allow auto scroll in the container.',
			},
			{
				name: 'autoscrollSensitivity,',
				type: 'number',
				default: '20',
				description: 'it is sensivity radius of the auto scroll when dragging in the container edge.',
			},
			{
				name: 'eventListenerOption',
				type: 'boolean | object',
				default: 'false',
				description: 'you can set your own options in addEventListener.',
			},
			{
				name: '}',
				type: '',
				default: '',
				description: '',
			},
		]
	}, 
	{
		name: ')',
		type: '',
		default: '',
		description: '',
	},
];  

const EventTypes = [
	{
		name: 'dragstart',
		type: '-',
		default: '-',
		description: 'it will be invoked when the user touch or click the container',
	},
	{
		name: 'dragmove',
		type: '-',
		default: '-',
		description: 'it will be invoked when the user is dragging inside container',
	},
	{
		name: 'dragend',
		type: '-',
		default: '-',
		description: 'it will be invoked when the user is drop the touch or click inside container',
	},
	{
		name: 'dragenter',
		type: '-',
		default: '-',
		description: 'it will be invoked when the user drag entered the droppable element inside container',
	},
	{
		name: 'dragover',
		type: '-',
		default: '-',
		description: 'it will be invoked when the user drag is moving in the droppable element inside container',
	},
	{
		name: 'dragexit',
		type: '-',
		default: '-',
		description: 'it will be invoked when the user drag exited the droppable element inside container',
	},
	{
		name: 'drop',
		type: '-',
		default: '-',
		description: 'it will be invoked when the user droped inside the droppable element',
	},
]

const MethodRows = [
	{
		name: 'Instance.on',
		type: 'void',
		default: '-',
		description: 'it is the method to add Dragger event listener',
		data: [
			{
				name: 'Instance.on(',
				type: '',
				default: '',
				description: '',
			},
			{
				name: 'eventType',
				type: 'string',
				default: '-',
				description: 'it is the type of event you want to add. the allowed type are the following dragstart, dragend, dragend, dragenter, dragexit and drop',
				data: EventTypes
			},
			{
				name: 'callback',
				type: 'function',
				default: '-',
				description: 'it is the callback that will be invoke when the eventType is triggered.',
			},
			{
				name: '): void',
				type: '',
				default: '',
				description: '',
			},
		]
	},
	{
		name: 'Instance.off',
		type: 'void',
		default: '-',
		description: 'it is the method to remove Dragger event listener',
		data: [
			{
				name: 'Instance.off(',
				type: '',
				default: '',
				description: '',
			},
			{
				name: 'eventType',
				type: 'string',
				default: '-',
				description: 'it is the type of event you want to remove. the allowed type are the following dragstart, dragmove, dragend, dragenter, dragexit and drop',
				data: EventTypes
			},
			{
				name: '): void',
				type: '',
				default: '',
				description: '',
			},
		]
	},
	{
		name: 'Instance.destroy',
		type: 'void',
		default: '-',
		description: 'it is use to destroy and kill the Dragger.',
	},
]

const EventsRows = [ 
	{
		name: 'type',
		type: 'string',
		default: '-',
		description: 'it is event type.',
	},
	{
		name: 'preventDefault',
		type: 'method',
		default: '-',
		description: 'it is use to prevent default.',
	},
	{
		name: 'stopPropagation',
		type: 'method',
		default: '-',
		description: 'it is use to stop the propagation.',
	},
	{
		name: 'originalEvent',
		type: 'object',
		default: '-',
		description: 'it is the original event',
	},
	{
		name: 'clientX',
		type: 'number',
		default: '-',
		description: 'it is the x position of the cursor in window',
	},
	{
		name: 'clientY',
		type: 'number',
		default: '-',
		description: 'it is the y position of the cursor in window',
	},
	{
		name: 'startX',
		type: 'number',
		default: '-',
		description: 'it is the start x position of the cursor in container.',
	},
	{
		name: 'startY',
		type: 'number',
		default: '-',
		description: 'it is the start y position of the cursor in container.',
	},
	{
		name: 'moveX',
		type: 'number',
		default: '-',
		description: 'it is the current x position of the cursor in container.',
	},
	{
		name: 'moveY',
		type: 'number',
		default: '-',
		description: 'it is the current y position of the cursor in container.',
	},
	{
		name: 'endX',
		type: 'number',
		default: '-',
		description: 'it is the end x position of the cursor in container.',
	},
	{
		name: 'endY',
		type: 'number',
		default: '-',
		description: 'it is the end y position of the cursor in container.',
	},
	{
		name: 'isDraggableElement',
		type: 'boolean',
		default: '-',
		description: 'it indicates if the targeted element is draggable.',
	},
	{
		name: 'target',
		type: 'element | node',
		default: '-',
		description: 'it is the element which is targeted.',
	},
	{
		name: 'container',
		type: 'element | node',
		default: '-',
		description: 'it is the element container.',
	},
	{
		name: 'droppable (dragover, dragenter, drop)',
		type: 'element | node',
		default: '-',
		description: 'it is the element inside droppable container where the target is landed. it might be the children of the droppable container.',
	},
	{
		name: 'currentDroppable (dragover, dragenter, dragexit, drop)',
		type: 'element | node',
		default: '-',
		description: 'it is the droppable container element which you want to drop (dragenter), you fail to drop (dragexit) or you dropped (drop).',
	},
]

export const Dragger = () => (
	<Section
		title='Dragger'>
		<Table.ForAPI nameLabel="Argument" data={DraggerRows} />
	</Section>
);

export const Methods = () => (
	<Section
		title='Dragger Methods'>
		<Table.ForAPI nameLabel="Method" typeLabel="Return" data={MethodRows} />
	</Section>
);

export const EventProp = () => (
	<Section
		title='Event Properties'>
		<Table.ForAPI data={EventsRows} />
	</Section>
);